import React from 'react';
import { ActivityIndicator, View } from 'react-native';

import { OrderContainer } from '@components/OrderView';
import { ScreenContent } from '@components/ScreenContent';
import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';
import { useParams } from '@hooks';
import { useHistoryOrder, useHistoryStore } from '@stores/historyOrders';

const useStyle = makeStyles((theme) => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'row',
    padding: theme.spacing(2),
  },
}));

export const OrderHistoryScreen: React.FC = () => {
  const { params } = useParams<'OrderHistory'>();
  const { loading } = useHistoryStore();
  const { order } = useHistoryOrder(params.id);

  const styles = useStyle();

  return (
    <ScreenContent>
      {order && !loading ? (
        <OrderContainer orderUUID={order.uuid} isHistoryOrderFlag={true} />
      ) : loading ? (
        <View style={styles.container}>
          <ActivityIndicator size="large" />
        </View>
      ) : (
        <Typography>
          Order with id # {params.id} is no longer in history
        </Typography>
      )}
    </ScreenContent>
  );
};
